module.exports = __webpack_public_path__ + "media/images/header-beauty-988a173548d401a7ea16cddaacc4e233.svg";